import { Tabs } from "@qgiv/core-donor";
import React from "react";

/**
 * @param {object} props - The component props.
 * @param {Function} props.handleClick - The click event handler for the tabs.
 * @param {Function} props.getLeftElementAttributes - The function to get attributes for the left tab element.
 * @param {Function} props.getRightElementAttributes - The function to get attributes for the right tab element.
 * @returns {React.JSX.Element}
 */
const DonatedGiftFrequencyTabs = ({
    handleClick,
    getLeftElementAttributes,
    getRightElementAttributes,
}) => {
    const tabData = [getLeftElementAttributes(), getRightElementAttributes()];

    return <Tabs handleClick={handleClick} size="large" tabData={tabData} />;
};

export default DonatedGiftFrequencyTabs;
